var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 3C1.6875 2.27513 2.27513 1.6875 3 1.6875H6.75C7.47489 1.6875 8.0625 2.27513 8.0625 3V6.75C8.0625 7.47488 7.47488 8.0625 6.75 8.0625H3C2.27513 8.0625 1.6875 7.47489 1.6875 6.75V3ZM3 2.8125C2.89645 2.8125 2.8125 2.89645 2.8125 3V6.75C2.8125 6.85356 2.89644 6.9375 3 6.9375H6.75C6.85356 6.9375 6.9375 6.85356 6.9375 6.75V3C6.9375 2.89644 6.85356 2.8125 6.75 2.8125H3Z",
    fill: "#0A49A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 11.25C1.6875 10.5251 2.27513 9.9375 3 9.9375H6.75C7.47488 9.9375 8.0625 10.5251 8.0625 11.25V15C8.0625 15.7249 7.47488 16.3125 6.75 16.3125H3C2.27513 16.3125 1.6875 15.7249 1.6875 15V11.25ZM3 11.0625C2.89644 11.0625 2.8125 11.1464 2.8125 11.25V15C2.8125 15.1036 2.89644 15.1875 3 15.1875H6.75C6.85356 15.1875 6.9375 15.1036 6.9375 15V11.25C6.9375 11.1464 6.85356 11.0625 6.75 11.0625H3Z",
    fill: "#0A49A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9375 3C9.9375 2.27513 10.5251 1.6875 11.25 1.6875H15C15.7249 1.6875 16.3125 2.27513 16.3125 3V6.75C16.3125 7.47488 15.7249 8.0625 15 8.0625H11.25C10.5251 8.0625 9.9375 7.47488 9.9375 6.75V3ZM11.25 2.8125C11.1464 2.8125 11.0625 2.89644 11.0625 3V6.75C11.0625 6.85356 11.1464 6.9375 11.25 6.9375H15C15.1036 6.9375 15.1875 6.85356 15.1875 6.75V3C15.1875 2.89644 15.1036 2.8125 15 2.8125H11.25Z",
    fill: "#0A49A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9375 11.25C9.9375 10.5251 10.5251 9.9375 11.25 9.9375H15C15.7249 9.9375 16.3125 10.5251 16.3125 11.25V15C16.3125 15.7249 15.7249 16.3125 15 16.3125H11.25C10.5251 16.3125 9.9375 15.7249 9.9375 15V11.25ZM11.25 11.0625C11.1464 11.0625 11.0625 11.1464 11.0625 11.25V15C11.0625 15.1036 11.1464 15.1875 11.25 15.1875H15C15.1036 15.1875 15.1875 15.1036 15.1875 15V11.25C15.1875 11.1464 15.1036 11.0625 15 11.0625H11.25Z",
    fill: "#0A49A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.3eeda7296eb63b9dffb87fea102c977b.svg";
export { ForwardRef as ReactComponent };